<template>
  <div class="my">
    <img src="../assets/back.jpg" class="back"/>
    <img :src="imgurl" class="ewm"/>
    <div class="foot">
      <div class="tabs"  @click="link(1)">
        <div class="tab tab1"></div>
        <div class="txt">首页</div>
      </div>
      <div class="tabs"  @click="link(2)">
        <div class="tab tab2"></div>
        <div class="txt">业绩查询</div>
      </div>
      <div  class="tabs on"  @click="link(3)">
        <div class="tab tab3"></div>
        <div class="txt">我的二维码</div>
      </div>
    </div>
  </div>
</template>

<script>
  let link='http://ap.bjcreate.net/school/'
  let openid
  let role
  export default {
    name: "my",
    data () {
      return {
        imgurl:''
      }
    },
    mounted() {
      openid=this.$route.query.openid
      role=this.$route.query.role
      console.log(openid)
      this.ismember()
    },
    created() {

    },
    methods:{
      ismember(){
        this.$axios.post(link+'api/school/isbind',
          {openid:openid}
        ).then(res=>{
          console.log(res.data)
          if(res.data.Code==200){
            this.getmyqrcode()
          }else{
            console.log(openid)
            //window.location.href='http://ap.bjcreate.net/school/school/Login/Index'
          }

        }).catch(error=>{
          console.log(error)
        })
      },
      getmyqrcode(){
        this.$axios.post(link+'api/school/myqrcode',
          {
            openid:openid,
          }
        ).then(res=>{
          console.log(res.data)
          this.imgurl=res.data.ResultData

        }).catch(error=>{
          console.log(error)
        })
      },
      link(e){
        console.log(e)
        if(e==1){
          this.$router.push({
            path:'/?o='+openid+'&r='+role
          })
        }else if(e==2){
          this.$router.push({
            path:'search?openid='+openid+'&role='+role
          })
        }else{

        }
      }
    },
    components:{

    }
  }
</script>

<style scoped>
  .contains{
    padding-bottom:1.6rem;
  }
  .foot{
    position: fixed;
    width:100%;
    height:1.3rem;
    background-color:#fff;
    left:0;
    bottom:0;
    font-size:0.22rem;
    display: flex;
    align-items:flex-start;
    justify-content: space-between;
    padding-top:0.2rem;
    color:#A8A8A8;
    box-shadow:2px 0px 5px rgba(0,0,0,0.2);
  }
  .foot>.tabs{
    width:2.3rem;
    text-align: center;
  }
  .tab1{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon9.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab1{
    background: url(../assets/icon9-on.png) no-repeat center top;
    background-size: 100%;
  }
  .foot>.on .txt{
    color:#FF9831;
  }

  .tab2{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon10.png) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab2 {
    background: url(../assets/icon10-on.png) no-repeat center top;
    background-size: 100%;
  }
  .tab3{
    width:0.4rem;
    height:0.4rem;
    background: url(../assets/icon16.jpg) no-repeat center top;
    background-size: 100%;
    margin:0 auto 0.1rem;
  }
  .tabs.on .tab3{
    background: url(../assets/icon16-on.jpg) no-repeat center top;
    background-size: 100%;
  }
  a{
    text-decoration:none;
    outline: none;	/* 去除旧版浏览器的点击后的外虚线框 */
    color: #000;
  }
  .txt{
    color:#A8A8A8;
  }
  .my{
    position: relative;
    padding-bottom:1.6rem;
  }
  .back{
    display: block;
    width:100%;
  }
  .ewm{
    position: absolute;
    width:3.67rem;
    display: block;
    left:50%;
    margin-left:-1.835rem;
    top:3.74rem;
  }
</style>





// WEBPACK FOOTER //
// src/components/my.vue